import React, { Component } from 'react'
import AppBar from 'material-ui/AppBar'
import { connect } from 'react-redux'
import Menu from 'material-ui/svg-icons/navigation/menu'
import ArrowBack from 'material-ui/svg-icons/navigation/arrow-back'
import IconButton from 'material-ui/IconButton'
import { goBack } from '../../../actions'
import { isLoggedIn } from '../../../utils/utils'
import './style.css'


const styles = {
  root: backgroundColor => ({ backgroundColor }),
  brand: {
    height: '60px',
    width: 'auto',
    position: 'absolute',
    top: '3px',
    left: '0',
    right: '0',
    margin: 'auto',
  },
}

class MainMenu extends Component {


  handleToggleSidebar = () => {
    this.props.toggleSidebar()
  }

  iconElementLeft = () => {
    if (isLoggedIn()) {
      return (
        <IconButton>
          { this.props.hasBack ? <ArrowBack /> : <Menu /> }
        </IconButton>
      )
    } else if (this.props.hasBack) {
      return (
        <IconButton>
          <ArrowBack />
        </IconButton>
      )
    }
    return <div />
  }

  iconElementRight = () => {
    if (this.props.xxxhdpi) {
      return <img src={this.props.xxxhdpi} style={styles.brand} alt="BadgeHeroes" />
    }
    return <div />
  }

  title = () =>
    (this.props.staging_mode ? 'Testing' : null)

  render() {
    return (
      <AppBar
        title={this.title()}
        style={{ position: 'fixed' }}
        iconElementLeft={this.iconElementLeft()}
        onLeftIconButtonTouchTap={
          this.props.hasBack ?
            this.props.goBack(this.props.currentPath) :
            this.handleToggleSidebar
        }
        iconElementRight={this.iconElementRight()}
      />
    )
  }
}

MainMenu.propTypes = {
  toggleSidebar: React.PropTypes.func.isRequired,
  xxxhdpi: React.PropTypes.string.isRequired,
  hasBack: React.PropTypes.bool.isRequired,
  goBack: React.PropTypes.func.isRequired,
  currentPath: React.PropTypes.string.isRequired,
}

const mapStateToProps = state => ({
  ...state.layout,
  staging_mode: state.user.staging_mode,
})

const mapDispatchToProps = dispatch => ({
  goBack: pathname => () => dispatch(goBack(pathname)),
})

export default connect(mapStateToProps, mapDispatchToProps)(MainMenu)



// WEBPACK FOOTER //
// ./src/components/Layout/MainMenu/index.jsx